import(/* webpackMode: "eager", webpackExports: ["VerticalHub"] */ "/vercel/path0/src/app/(general)/industries/VerticalHub.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerticalHubContent"] */ "/vercel/path0/src/app/(general)/industries/VerticalHubContent.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Faq"] */ "/vercel/path0/src/components/faq/faq.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/header/header.comp.tsx");
